import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { KeyRound, ArrowLeft, UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import portalApi, { savePortalSession } from '../../utils/portalApi';

const PortalLogin = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleaned = code.trim().toUpperCase();
    if (!cleaned) {
      toast.error('Ingresa tu código de acceso');
      return;
    }
    setLoading(true);
    try {
      const res = await portalApi.post('/portal/login', { code: cleaned });
      savePortalSession(res.data.token, res.data.client);
      toast.success(`Bienvenido ${res.data.client.name}`);
      navigate('/portal');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al ingresar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="portal-back-home"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-3 h-3" />
          Volver al inicio
        </Link>

        <div className="bg-[#0A0A0A] border border-white/10 p-8 md:p-10">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
              <KeyRound className="w-6 h-6 text-white" />
            </div>
          </div>
          <h1 className="font-['Playfair_Display'] text-3xl text-center mb-2">Portal Clientes</h1>
          <p className="text-center text-sm text-white/50 mb-8">
            Ingresa tu código de acceso personal
          </p>

          <form onSubmit={handleSubmit} data-testid="portal-login-form" className="space-y-5">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] mb-2 text-white/60">
                Código de acceso
              </label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase().slice(0, 5))}
                placeholder="A1234"
                maxLength={5}
                autoFocus
                data-testid="portal-code-input"
                className="w-full bg-[#121212] border border-white/10 focus:border-white/30 px-4 py-4 text-white text-center text-2xl tracking-[0.5em] font-mono outline-none"
              />
              <p className="text-[10px] text-white/40 mt-2 text-center">
                1 letra + 4 dígitos (ej: A1234). Solicítalo a tu administrador.
              </p>
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="portal-login-submit"
              className="w-full bg-white text-black hover:bg-gray-200 transition-colors duration-300 px-6 py-4 text-xs uppercase tracking-[0.2em] font-semibold disabled:opacity-50"
            >
              {loading ? 'Verificando...' : 'Ingresar'}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-white/10 text-center">
            <p className="text-xs text-white/50 mb-3">¿Aún no eres cliente?</p>
            <Link
              to="/portal/register"
              data-testid="portal-go-register"
              className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white border border-white/20 hover:bg-white/5 px-5 py-2.5 transition-colors"
            >
              <UserPlus className="w-3 h-3" />
              Registrarme como cliente
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalLogin;
